import React from "react";

const LiveUsersIndex = () => {
  return <div>Exam Stats</div>;
};

export default LiveUsersIndex;
